/* Knurlhouse: make in-page links such as /#faq work.
   Desktop: Horizon scrolls inside .page-wrapper and sets history.scrollRestoration to
   'manual', so the browser's own jump to a #fragment after navigation never happens.
   Phone: arriving from the menu drawer, Horizon's scroll lock/restore can reset the
   page to the top after the jump. So scroll the target into view ourselves, and retry
   briefly in case something resets it, but stop as soon as the visitor scrolls, and
   never override Horizon's own back/forward scroll restoration. */
(function () {
  var visitorScrolled = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
    window.addEventListener(type, function () { visitorScrolled = true; }, { passive: true, once: true });
  });

  function target() {
    if (!location.hash || location.hash.length < 2) return null;
    try {
      return document.getElementById(decodeURIComponent(location.hash.slice(1)));
    } catch (e) {
      return null;
    }
  }

  function scrollToHash(force) {
    var el = target();
    if (!el || (visitorScrolled && !force)) return;
    var top = el.getBoundingClientRect().top;
    if (force || top < 0 || top > 200) el.scrollIntoView({ block: 'start', behavior: 'instant' });
  }

  window.addEventListener('pageshow', function () {
    if (history.state && history.state.scrollTop != null) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { scrollToHash(false); });
    });
    [300, 800, 1500].forEach(function (ms) {
      setTimeout(function () { scrollToHash(false); }, ms);
    });
  });

  window.addEventListener('hashchange', function () { scrollToHash(true); });
})();
